import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { CHALLENGES } from '../constants'
import { ChallengeFormInput } from '../types'
import { transformChallengeInput } from '../utils'

const updateChallenge = async ({
  form,
  id,
}: {
  form: ChallengeFormInput
  id: number
}) => {
  console.log(form)
  const data = transformChallengeInput(form)

  await fetchAPI({
    method: 'put',
    path: `/challenges/${id}`,
    data,
  })
}

export const useUpdateChallenge = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateChallenge, {
    onSuccess: async () => {
      await queryClient.refetchQueries([CHALLENGES])

      toast({
        description: t('views.admin.challenges.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
